import { css } from 'emotion';

import { colors, fonts, icons } from '@cobliteam/base-components/src/styles';

export const notificationsIcon = css`
  height: ${icons.size.medium};
  width: ${icons.size.medium};
  color: ${colors.gray.dark};
`;

export const button = css`
  height: 54px;
  padding: 0 10px;
  margin-right: 40px;
  display: flex;
  align-items: center;
  color: ${colors.gray.default};
  font-size: ${fonts.size.small};
  position: relative;

  :hover {
    cursor: pointer;
    background-color: ${colors.custom.lightestGray50};
  }
`;

export const incidentsAndTrips = css`
  display: flex;
`;

export const popupWrapper = css`
  position: absolute;
  bottom: 0;
  transform: translate(-25px, calc(100% + 5px));
`;
